// Predict only the waiting label from the request settings. Visible reasoning
// always comes from provider events, never from this capability check.
export const expectsReasoning = (model, { isThinking, isDeepResearch, reasoningLevel } = {}) => {
  const id = model?.modelString || model?.id || '';
  const effort = String(reasoningLevel || 'auto').toLowerCase();
  if (/^(muse-spark-|openai\/gpt-oss-|gpt-6-astra(?:$|-)|grok-4\.[67](?:$|-))/.test(id)) return true;
  if (/^gemini-3(?:\.|-)/.test(id) || /^gemini-2\.5-pro/.test(id)) return true;
  if (/^claude-(?:opus-5|sonnet-5|fable-|mythos-)/.test(id)) return true;
  if (model?.provider === 'DeepSeek Reasoning') return true;
  if (effort === 'none') return false;
  return Boolean(isThinking || isDeepResearch);
};
